document.addEventListener('DOMContentLoaded', () => {

    const imageDownloadModal = '.js-image-modal'
    const searchModal = '.js-search-modal'
    const locationModal = '.c-modal'
    const newsletterModal = '.js-newsletter-modal'
    const productOnRequestModal = '.js-product-on-request-modal'

    document.body.addEventListener('click', function (e) {
        closeModalOnSideClick(e, imageDownloadModal, 'open')
        closeModalOnSideClick(e, locationModal, 'isActive')
        closeModalOnSideClick(e, newsletterModal, 'open')
        closeModalOnSideClick(e, productOnRequestModal, 'open')
    })

    function closeModalOnSideClick(clickEvent, modalClass, classToRemove) {
        const clickedTarget = clickEvent.target
        const documentBody = document.body
        const element = document.querySelector(modalClass)

        if (element !== null && clickedTarget.classList.contains(classToRemove)) {
            document.querySelector(modalClass).classList.remove(classToRemove)
            documentBody.classList.contains('no-scroll') ? documentBody.classList.remove('no-scroll') : false
        }

    }

    document.body.addEventListener('keydown', function (e) {
        if (e.key === "Escape") {
            closeModalOnEscape(imageDownloadModal, 'open')
            closeModalOnEscape(locationModal, 'isActive')
            closeModalOnEscape(newsletterModal, 'open')
            closeModalOnEscape(productOnRequestModal, 'open')
            closeModalOnEscape(searchModal, 'open', true)

        }
    })
    function closeModalOnEscape(modalClass, classToRemove, removeHeaderScrollClass = false) {
        const documentBody = document.body
        const element = document.querySelector(modalClass)

        if (element !== null && element.classList.contains(classToRemove)) {
            document.querySelector(modalClass).classList.remove(classToRemove)
            documentBody.classList.contains('no-scroll') ? documentBody.classList.remove('no-scroll') : false
        }

        if (removeHeaderScrollClass) {
            const header = document.querySelector('.l-header')
            header.classList.remove('l-header--scroll')
        }
    }

})
